import { useTranslation } from 'react-i18next';
import { WifiOff, Cloud, Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export default function OfflineBanner() {
  const { t } = useTranslation('scout');
  const { isOnline, pendingCount, sync } = useNetworkStatus();
  const [syncing, setSyncing] = useState(false);

  // Hide when online and nothing pending
  if (isOnline && pendingCount === 0) return null;

  const handleSync = async () => {
    setSyncing(true);
    await sync();
    setSyncing(false);
  };

  return (
    <div className="fixed bottom-20 inset-x-4 z-30 flex justify-center">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground text-background text-small shadow-lg">
        {!isOnline ? (
          <>
            <WifiOff className="w-4 h-4 text-critical" />
            <span>{t('offline.offlineBanner')}</span>
            {pendingCount > 0 && (
              <span className="bg-critical text-white text-caption font-bold px-1.5 py-0.5 rounded-full">
                {pendingCount}
              </span>
            )}
          </>
        ) : (
          <>
            <Cloud className="w-4 h-4 text-steel" />
            <span>{t('offline.pendingScans', { count: pendingCount })}</span>
            <button
              onClick={handleSync}
              disabled={syncing}
              className="ms-1 px-2 py-0.5 rounded-full bg-white/20 text-caption font-medium hover:bg-white/30 disabled:opacity-50"
            >
              {syncing ? (
                <Loader2 className="w-3 h-3 animate-spin" />
              ) : (
                t('offline.syncing').split('...')[0]
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
